// src/lib/providerCatalog.jsx

// Mock “abonnementen” + content.
// Je mag de URLs later vervangen door andere HLS streams.

export const PROVIDER_CATALOG = {
  free: {
    id: "free",
    label: "Free",
    description: "Gratis demo-kanalen om Bond te proberen.",
    items: [
      {
        id: "free-demo-1",
        title: "Free demo match",
        subtitle: "Open demo kanaal",
        // Bekende publieke HLS-demo
assetUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
      },
    ],
  },

  sports: {
    id: "sports",
    label: "Sports",
    description: "Extra sportkanalen voor sport-abonnees.",
    items: [
      {
        id: "sports-demo-1",
        title: "Sports demo match",
        subtitle: "Sportkanaal demo",
        assetUrl:
          "https://bitdash-a.akamaihd.net/content/sintel/hls/playlist.m3u8",
      },
    ],
  },

  all_access: {
    id: "all_access",
    label: "All Access",
    description: "Toegang tot alle demo-kanalen (premium).",
    items: [
      {
        id: "all-demo-1",
        title: "All Access demo 1",
        subtitle: "Kanaal 1 – premium demo",
assetUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
      },
      {
        id: "all-demo-2",
        title: "All Access demo 2",
        subtitle: "Kanaal 2 – andere demo",
        assetUrl:
          "https://bitdash-a.akamaihd.net/content/sintel/hls/playlist.m3u8",
      },
    ],
  },
};

// Kleine helpers voor later (wedstrijd kiezen UI, etc.)
export function getPackageById(id) {
  if (!id) return null;
  return PROVIDER_CATALOG[id] || null;
}

export function getAsset(providerId, assetId) {
  const pkg = getPackageById(providerId);
  if (!pkg) return null;
  return (pkg.items || []).find((it) => it.id === assetId) || null;
}
